// This is needed because @brigthcove/react-player-loader us using the `global` npm
// package which is in CJS. But for some reason window.__esModule is set to true in our iOS
// app webviews and that breaks the usage of the CJS `global` package. By providing ESM versions
// we bypass the problem with window.__esModule being defined.
let win

if (typeof window !== 'undefined') {
  win = window
} else if (typeof global !== 'undefined') {
  win = global
} else if (typeof self !== 'undefined') {
  win = self
} else {
  win = {}
}

export default win
